import type { AppearanceVariant } from '../types';

import { BenchPreview } from '../previews/workbench';

export const workbenchVariant: AppearanceVariant = {
  id: 'workbench',
  nameKey: 'appearance.workbench',
  descriptionKey: 'appearance.workbenchDescription',
  className: 'erp-workbench',
  composition: 'split',
  groupedNavigation: true,
  documentEntry: 'guided',
  Preview: BenchPreview,
};
